import { Box, Image } from '@jfs/ui-new'
import { useIsFocused } from '@react-navigation/core'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { Animated, Easing } from 'react-native'

export const ImageLoopAnimation = ({ src }: any) => {
  const merchantsLogo = src
  const [animatedValue] = useState<any>(new Animated.Value(0))

  const animation = useMemo(
    () =>
      Animated.timing(animatedValue, {
        toValue: 1,
        duration: 10000,
        easing: Easing.linear,
        useNativeDriver: true,
        delay: 0,
      }),
    [animatedValue],
  )
  const startAnimation = useCallback(() => {
    animatedValue.setValue(0)
    animation.start(() => startAnimation())
  }, [animatedValue, animation])

  const stopAnimation = () => {
    animatedValue.setValue(0)
    animation.stop()
  }

  const animate = {
    transform: [
      {
        translateX: animatedValue.interpolate({
          inputRange: [0, 1],
          outputRange: [0, -690],
        }),
      },
    ],
  }

  const animateSecond = {
    transform: [
      {
        translateX: animatedValue.interpolate({
          inputRange: [0, 1],
          outputRange: [690, 0],
        }),
      },
    ],
  }
  const isFocused = useIsFocused()

  useEffect(() => {
    isFocused && startAnimation()
    stopAnimation()
  }, [isFocused, startAnimation, stopAnimation])
  return (
    <Box>
      <Animated.View style={[animate, { alignContent: 'center', paddingVertical: 40 }]}>
        <Image resizeMode={'contain'} source={merchantsLogo} width={690} height={64} />
      </Animated.View>
      <Box position={'absolute'} top={0}>
        <Animated.View style={[animateSecond, { alignContent: 'center', paddingVertical: 40 }]}>
          <Image resizeMode={'contain'} source={merchantsLogo} width={690} height={64} />
        </Animated.View>
      </Box>
    </Box>
  )
}
